import { Component } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { FooterService } from './footer.service';
import { BlockingTaskService } from 'src/commons/services/blockingtask/blockingTask.service';
import { LoginService } from '../login/login.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {

  version: string = '';
  observablesSubject = new Subject<void>();
  rutaActual: string = '/';

  constructor(private router: Router, private footerService: FooterService, private loginService: LoginService) { }

  ngOnInit(): void {
    this.rutaActual = this.router.url;
    
    if(this.loginService._userToken){
      this.obtenerVersion();
    }
  }

  obtenerVersion() {
    this.footerService.getFooterData().then((datos) => {
      this.version = datos.version;
    });
  }
    
}
